import toast from "react-hot-toast";
import { useClientBookingContext } from "@/contexts/clientBookingContext";
import { useCreateClientSecretForBookingMutation } from "@/graphql/mutations/createClientSecretForBooking.graphql.types";
import { BookingStep, ClientDetailsInput } from "@/types/bookingTypes";
import { hasDjangoMutationError } from "@/utils/djangoMutationError";
import useErrorLogger from "@/utils/useErrorLogger";

export default function useBookingClientDetails() {
  const logError = useErrorLogger();
  const {
    medspaData,
    collectCardInformation,
    setClientDetails,
    setClientSecret,
    setStep,
    handleBookingSubmit,
  } = useClientBookingContext();

  const [createClientSecretForBooking] =
    useCreateClientSecretForBookingMutation();

  // ACTIONS
  const getClientSecret = async (data: ClientDetailsInput) => {
    try {
      const { data: clientSecretData } = await createClientSecretForBooking({
        variables: {
          ...data,
          medspaSlug: medspaData.slug,
        },
      });

      setClientSecret(clientSecretData.createClient.clientSecret);
      return clientSecretData.createClient.clientSecret;
    } catch (errors) {
      logError(errors);
      toast.error(
        hasDjangoMutationError(errors)
          ? errors.message
          : `There was a problem creating your account. Please contact ${medspaData.name} for assistance.`
      );
    }
  };

  const handleClientDetailsSubmit = async (data: ClientDetailsInput) => {
    const secret = await getClientSecret(data);
    if (secret) setStep(BookingStep.COLLECT_CREDIT_CARD_INFO);
  };

  const onSubmit = async (data: ClientDetailsInput) => {
    setClientDetails(data);

    if (collectCardInformation) {
      return await handleClientDetailsSubmit(data);
    }

    await handleBookingSubmit(data);
  };

  return {
    onSubmit,
    getClientSecret,
  };
}
